<template>
  <div>
    <b-dropdown
        class="dropdown-btn"
        :class="{ invertColor: invertColor}"
        :toggle-class="{ 'dropdownMenu': true, invertColor: invertColor }"
        variant="outline"
        :offset="offset"
        menu-class="menu-custom"
        no-caret
    >
      <template v-slot:button-content>
        <span :class="{ small: fontSize ==='small' }" class="username">{{ defaultValue }}</span>
        <profile-image
          :src="imageUrl"
          :user="{ full_name: defaultValue }"
          v-if="imageUrl"
          width="25px"
          height="25px"/>
        <font-awesome-icon icon="chevron-down" class="chevron-icon"/>
      </template>
      <slot/>
    </b-dropdown>
  </div>
</template>

<script>
import ProfileImage from '../ProfileImage/ProfileImage';

export default {
  name: 'Dropdown',
  components: {
    ProfileImage,
  },
  props: {
    defaultValue: {
      type: String,
      default: 'Username',
    },
    invertColor: {
      type: Boolean,
      default: false,
    },
    imageUrl: {
      type: String,
      default: '',
    },
    offset: {
      type: Number,
      default: -90,
    },
    fontSize: {
      type: String,
      default: 'normal',
    },
  },
};
</script>

<style lang="scss">

</style>
